import { Component } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { UNHMembershipPrincingTranslation, UNHFaqTranslation } from '@frontend/unhideschool/app/utils/i18n/locale/unh-membership-pricing/unh-membership-pricing.i18n.model';
import { UseTranslations } from '@frontend/unhideschool/app/utils/i18n/use-translation.decorator';

interface Translations {
  "unh-membership-pricing": UNHMembershipPrincingTranslation;
}

@Component({
  selector: 'unh-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})

@UseTranslations({
  translatableComponents : ["unh-membership-pricing"]
})

export class FaqComponent {
  panelOpenState = false;
  faqExpanded = false;
  lessonsExpanded = false;

  faqTranslation : UNHFaqTranslation[];
  membershipPricingMock : UNHMembershipPrincingTranslation;

  translations: Promise<Translations>;

  ngOnInit(): void {
    this.translations.then((translations) => {
      this.membershipPricingMock = translations['unh-membership-pricing'];
    })
  }

  togglePanelExpanded(panelExpandedKey: string, matPanel: MatAccordion) {
    this[panelExpandedKey] = !this[panelExpandedKey];

    if (this.lessonsExpanded) {
      matPanel.openAll();
    } else {
      matPanel.closeAll();
    }
  }
}
